import { BottomSheetDialog, Box } from '@medely/web-components';
import useDevice from '@mp/hooks/useDevice.web';
import React from 'react';
import { EducationModalProps } from './interface';
import { EducationForm } from '@mp/components/educationForm/EducationForm';
import { VStack } from '@medely/ui-kit';

export const EducationModal = ({ onClose, open, education }: EducationModalProps) => {
  const isDesktop = useDevice() === 'desktop';
  const title = education ? 'Edit education' : 'Add education';

  return (
    <>
      <BottomSheetDialog
        maxWidth={false}
        data-testid="education-modal"
        title={title}
        onClose={onClose}
        content={
          <Box width="90vw" maxWidth="600px">
            <VStack flex={1} pb={8}>
              <EducationForm
                onSuccess={() => onClose?.()}
                education={education}
                isModal
                titleText={title}
              />
            </VStack>
          </Box>
        }
        isDesktop={isDesktop}
        open={open}
      />
    </>
  );
};
